export default "__VITE_ASSET__a87837d1__"